import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {styles} from '../styling/component/CourseDetailsDrawer'
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import dateService from '../services/dateService'
import _ from 'lodash';
import cx from 'classnames';
import {
  WithStyles,
  createStyles,
  Drawer,
  Grid,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from '@material-ui/core';
import {
  CloseOutlined as CloseIcon,
} from '@material-ui/icons';

import {
  MyPATIconButton,
  MyPATProfileBox,
} from '../../common';
import { components } from '../../user-management';
import ContentData from '../components/Types/ContentData'



interface CourseDetailsDrawerProps extends WithStyles<typeof styles>{
  isDetailsDrawerOpen: boolean;
  content: ContentData,
  onDetailDrawerClose: () => void,
  drawerData:any
}

const CourseDetailsDrawer = (props:CourseDetailsDrawerProps) => {
  const {
    classes,
    isDetailsDrawerOpen,
    onDetailDrawerClose,
    content,
    drawerData
  } = props;

  if(drawerData==""){
    return   <Drawer
          anchor="right"
          open={isDetailsDrawerOpen}
          onClose={onDetailDrawerClose}
          ModalProps={{
            disableBackdropClick: true
          }}
          classes={{ paper: classes.drawerPaper }}
        >
       </Drawer>
  }
  var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  let createdAt = drawerData["createdAt"] === "" ? "" : new Date(drawerData["createdAt"]).toLocaleString('en-us', options)
  let updatedAt = drawerData["updatedAt"] === "" ? "" : new Date(drawerData["updatedAt"]).toLocaleString('en-us', options)
  let publishedAt = drawerData["publishedAt"] === "" ? "" : new Date(drawerData["publishedAt"]).toLocaleString('en-us', options)
  const batchArr:any = [];
	const goals:any = [];
  let goalsData = drawerData["goals"] || [];
    if(goalsData !="")
      {			
        goalsData.map(function(v:any,p:any){
            goals.push(`${v.name} ${v.category ? v.category.name : ""}`);
        });
      }
     const contributors:any = [];
     let contributorsList = drawerData.contributors || [];
     if(contributorsList!='')
     {
      contributorsList.map(function(v:any,p:any){ 
        let profileImage = v.profileImage?v.profileImage:"";
        if(v.firstName)
        {
        let fullname = v.firstName;
        let roleList:any = [];
        if(v.roles)
        {
          v.roles.map(function(v:any,p:any){
             roleList.push(`${v.roleId.role ? v.roleId.role : ""}`);
          });
        }
        contributors.push(<MyPATProfileBox
          avatarProps={{
            src: profileImage,
            alt: {fullname},
            title: {fullname},
            style: { height: 32, width: 32 }
          }}
          profileBoxProps={{
            style: { marginBottom: 8 }
          }}
          profileTitleProps={{
            variant: 'body2',
            classes: { root: classes.fwRegular},
          }}
          title={fullname} 
          caption={roleList}
          variant="inline"
        /> );
        }
    });
     }  

     const publishedBy:any = [];
     let publishedByList = drawerData.publishedBy;
     if(publishedByList!='')
     {
        let profileImage = publishedByList.profileImage?publishedByList.profileImage:"";
        if(publishedByList.firstName)
        {
        let fullname = publishedByList.firstName;
        let roleList:any = [];
        if(publishedByList.roles)
        {
          publishedByList.roles.map(function(v:any,p:any){
             roleList.push(`${v.roleId.role ? v.roleId.role : ""}`);
          });
        }
        publishedBy.push(<MyPATProfileBox
          avatarProps={{
            src: profileImage,
            alt: {fullname},
            title: {fullname},
            style: { height: 32, width: 32 }
          }}
          profileBoxProps={{
            style: { marginBottom: 8 }
          }}
          profileTitleProps={{
            variant: 'body2',
            classes: { root: classes.fwRegular},
          }}
          title={fullname} 
          caption={roleList}
          variant="inline"
        /> );
        }
     }  


     

     const shareWith:any = [];
     let shareWithList : any = []
     if(drawerData.aclMetaData && drawerData.aclMetaData.allowedTo && drawerData.aclMetaData.allowedTo.length>0){
      shareWithList = drawerData.aclMetaData.allowedTo
     }
     
     if(!!shareWithList.length)
     {
      shareWithList.map(function(v:any,p:any){ 
        let userDetail = v.user.id || []; 
        let profileImage = v.profileImage?v.profileImage:"";
        if(userDetail.firstName)
        {
          let fullname = userDetail.firstName;
          let roleList:any = [];
          if(userDetail.roles)
          {
            userDetail.roles.map(function(rolev:any,rolei:any){
              roleList.push(`${rolev.roleId.role ? rolev.roleId.role : ""}`);
            });
          }
          let permission = ""
         if(v.accessAllowed.length == 1){
           permission = "View Only"
         }else{
           permission = "Can Edit"
         }
          shareWith.push(<><Typography variant="body2" className={classes.fwRegular}>
            {permission}
        </Typography><MyPATProfileBox
            avatarProps={{
              src: profileImage,
              alt: {fullname},
              title: {fullname},
              style: { height: 32, width: 32 }
            }}
            profileBoxProps={{
              style: { marginBottom: 8 }
            }}
            profileTitleProps={{
              variant: 'body2',
              classes: { root: classes.fwRegular},
            }}
            title={fullname} 
            caption={roleList}
            variant="inline"
          /></> );
        }
    });
     }  


     const classVal:any = [];
     let classesData = drawerData["syllabus"]["class"] || [];
       if(classesData !="")
         {            
          classesData.map(function(v:any,p:any){
            if( p != classesData.length-1 ){
              classVal.push(`${v.name},`);
            } 
            else{
              classVal.push(`${v.name}`);
            }
           });
           
         }
         
         const subjects:any = [];
         let subjectsData = drawerData["syllabus"]["subjects"] || [];
           if(subjectsData !="")
             {			
              subjectsData.map(function(subv:any,subi:any){
                subjects.push(<Typography variant="body2" className={classes.fwRegular} color="textSecondary">
                  {subv._id}( {subv.chapters || 0} Chapters, {subv.concepts || 0} Concepts)
                </Typography>);
               });
             }

             const tags:any = [];
             let tagsData = drawerData["setting"]["tags"] || [];
               if(tagsData !="")
                 {			
                  tagsData.map(function(v:any,p:any){
                    tags.push(<Typography variant="body2" className={classes.fwRegular} color="textSecondary">
                    {v.tagName ? v.tagName : ""} : {v.value ? v.value : ""}
                  </Typography>);
                   });
                 }

         
  
  return(
    <ClickAwayListener onClickAway={onDetailDrawerClose}>
        
    <Drawer
      anchor="right"
      open={isDetailsDrawerOpen}
      onClose={onDetailDrawerClose}
      classes={{ paper: classes.drawerPaper }}
    >
      <Grid container>
        <Grid item xs={12} className={classes.drawerHeader}>
          <Typography variant="h6" noWrap className={classes.drawerTitle}>{drawerData["name"]}</Typography>
          <MyPATIconButton buttonVariant="transparent" onClick={onDetailDrawerClose}>
            <CloseIcon classes={{ root: classes.iconRoot }} />
          </MyPATIconButton>
        </Grid>

        <Grid item xs={12} className={classes.drawerBody}>
          <Typography variant="body1" className={classes.detailsTitle}>General Info</Typography>
          <Table className={classes.detailsTable}>
            <TableBody>
                <TableRow>
                  <TableCell>Course ID</TableCell>
                  <TableCell>{drawerData.courseId}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell className={classes.goalsData}>Goals</TableCell>
                  <TableCell>{goals.join(' | ')}</TableCell>
                </TableRow>
              { 
                publishedBy != "" 
                ? 
                <TableRow>
                  <TableCell>Published</TableCell>
                  <TableCell>{dateService.timeDate(drawerData["publishedAt"])}</TableCell>
                </TableRow>
                :
                  <></>
              }
              
              {
                updatedAt !== "" 
                ? 
                <TableRow>
                  <TableCell>Last Modified</TableCell>
                  <TableCell>{dateService.timeDate(drawerData["updatedAt"]) /*12:29 PM Oct 28*/}</TableCell>
               
                </TableRow>
                :
                  <></>
              }
               {
                createdAt !== "" 
                ? 
                <TableRow>
                  <TableCell>Created</TableCell>
                  <TableCell>{dateService.timeDate(drawerData["createdAt"])}</TableCell>
                </TableRow>
                :
                  <></>
              }
            </TableBody>
          </Table>

         <Typography variant="body1" className={classes.detailsTitle}>
          Course Syllabus
          </Typography>
          <Typography variant="body1" className={cx(classes.fwRegular, classes.classVal)}>For Class: {classVal}</Typography>
           {subjects}
          <Typography variant="body1" className={classes.detailsTitle}>Contributors</Typography>
            {contributors}
            {
              publishedBy != ""?
              <>
              <Typography variant="body1" className={classes.detailsTitle}>Published By</Typography>
              {publishedBy}
              </>
              :
              <></>
            }
            
          <Typography variant="body1" className={classes.detailsTitle}> Shared With</Typography>
            {shareWith}
          <Typography variant="body1" className={classes.detailsTitle}>
           Tags
            </Typography>
                 <Typography variant="body2" className={classes.fwRegular}>
                   {tags}
            </Typography>
            
        </Grid>
      </Grid>
    </Drawer>
    </ClickAwayListener>
  )
}

export default withStyles(styles)(CourseDetailsDrawer);